import { Injectable } from '@angular/core';
import { FiBackendService } from '../../../fi-backend/fi-backend.service';
import {
    IChecklist2ReportDateRange,
    IChecklist2ReportRecentActivity,
    IChecklistV2ReportParameterFilter,
} from '../shared/fi-checklist2-report';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';

@Injectable()
export class FiChecklist2ReportRecentActivityService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
    ) {}

    getChecklistRecentActivity(
        currentFilter: IChecklistV2ReportParameterFilter,
        dateRange: IChecklist2ReportDateRange,
        auditMode: boolean,
    ) {
        const url = `Checklist/Checklist2ReportRecentActivity/GetChecklistRecentActivity?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<IChecklist2ReportRecentActivity[]>(url, {
                filter: currentFilter,
                dateRange: dateRange,
            }),
        );
    }
}
